/**
 * Octavia Theme
 */
if(typeof $ === undefined) {
	const $ = jQuery.noConflict();
}

function OctaviaTheme(options) {
	if(!options) options = {};
	this.options = options;

	if ( ! this.isSetup ) {
		this.setup();
	}
}

OctaviaTheme.prototype.setup = function() {

	this.isSetup = true;

	// General.
	this.$window          = $( window );
	this.$document 	      = $( document );
	this.$html            = $( 'html' );
	this.$body            = $( 'body' );
	this.$pageMenu        = $( '.js-page-menu' );
	this.$menu            = $( '.primary-menu' );
	this.$menuItem        = this.$menu.find( '> li' );
	this.$submenu         = $( '.sub-menu' );
	this.$submenuItem 	  = this.$menu.find( '> .menu-item-has-children' );
	this.$submenuItemLink = this.$submenuItem.find( '> a' );
	this.$menuButton  	  = $( '.js-page-menu-button' );

	// Products.
	this.$productGallery = $( '.js-product-gallery' );
	this.$products       = $( 'ul.products' );
	this.$product        = this.$products.find( '.product' );

	this.scrollListener = null;

	// Single Product: Setup gallery.
	this.setupSingleProductGallery();
	this.setupProductNavigationKeyboard();

	// Setup page transitions.
	this.setupPageTransitions();
	this.runAutoLinks();
	this.initHomeSlider();

	this.loadMore = new LoadMore();
	// loadMore.show(); !

	// Menu item: Hover.
	this.$submenuItem.off( 'mouseenter mouseleave' ).on({
		mouseenter: (e) => {
			const $this    = $( e.currentTarget );
			const isHoveringOnLink = e.target.tagName.toLowerCase() === 'a';
			if ( isHoveringOnLink ) {
				this.$currentSubmenu = $this.find( '> .sub-menu' );
				this.toggleDropdownMenu( this.$currentSubmenu, true );
			}
		},
		mouseleave: (e) => {
			const $this   = $( e.currentTarget );
			const $target = $( e.target );
			const isHovering = $this.hasClass( 'sub-menu' );

			if ( this.$currentSubmenu && ! isHovering ) {
				this.toggleDropdownMenu( this.$currentSubmenu, false );
				this.$currentSubmenu = null;
			}
		}
	});

	// Menu item: Click / Touch.
	this.$submenuItem.off( 'touchstart' ).on('touchstart', '> a', (e) => {
		const $this    = $( e.currentTarget );
		const $target  = $( e.target );
		const $parent = $target.closest('.menu-item-has-children');

		if ( $parent.length ) {
			e.preventDefault();

			if ( this.$currentSubmenu ) {
				this.toggleDropdownMenu( this.$currentSubmenu, false );
			}
			this.$currentSubmenu = $parent.find( '> .sub-menu' );

			this.toggleDropdownMenu( this.$currentSubmenu, true );
		}
	});

	// Submenu: Click anywhere to close
	$(document).off('click touchstart').on('click touchstart', '.page-body',(e) => {
		if ( this.$currentSubmenu ) {
			console.log("matched");
			this.toggleDropdownMenu( this.$currentSubmenu, false );
			this.$currentSubmenu = null;
		}
	});

	// Menu button: Click / Touch
	this.$menuButton.off().on( 'click touchstart', (e) => {
		if (e.cancelable) {
			e.preventDefault();
		}
		this.toggleMenu();
	});

	// window.addEventListener('resize', this.resizeWorkImage); !
	this.setupSingleProductGallery();
}

OctaviaTheme.prototype.toggleMenu = function(state) {
	this.$body.toggleClass( "page-menu-open" );
};

OctaviaTheme.prototype.toggleDropdownMenu = function($submenu, state) {
	const showMenu = state !== undefined ? state : null;

	if ($submenu.length) {
		const submenuHeight  = $submenu.height();
		const revealerHeight = $submenu[0].scrollHeight;

		// Set height based on current menu state.
		let newHeight = (submenuHeight > 0 ? 0 : revealerHeight);
		if (null !== showMenu) {
			newHeight = (showMenu ? revealerHeight : 0);
		}

		$submenu.stop().animate(
			{ height: `${newHeight}px`},
			{
				duration: 250,
				easing: 'easeInOutQuad',
				complete: (e) => {}
			}
		);
	}
};

OctaviaTheme.prototype.setupPageTransitions = function() {
	this.swup = new Swup({
		cache: false,
		containers: ["#swup"],
		animationSelector: '[class*="transition-"]',
		linkSelector:
		'a[href^="' + window.location.origin + '"]:not([data-no-swup]):not(.data-no-swup),' +
		'a[href^="/"]:not([data-no-swup]):not(.data-no-swup),' +
		'a[href^="#"]:not([data-no-swup]):not(.data-no-swup)',
		plugins: [
			new SwupHeadPlugin()
		],
	});

	this.swup.on('clickLink', (e) => {
		const $targetLink = $( e.target ).closest( 'a' );

		if ( ! $targetLink.closest( this.$menu ).length ) {
			return;
		}

		const $menuItems = $targetLink.parentsUntil( this.$menu, 'li' );

		this.$menu
			.find( '.current-menu-item, .current-menu-parent, .current-menu-ancestor' )
			.removeClass( 'current-menu-item current-menu-parent current-menu-ancestor' );
		$menuItems.first().addClass( 'current-menu-item' );
		$menuItems.slice( 1 ).addClass( 'current-menu-parent' );
	});

	this.swup.on( 'willReplaceContent', (event) => {
		window.scrollTo( 0, 0 );
		// this.reset(); !
	});

	this.swup.on( 'contentReplaced', (event) => {
		this.syncBodyClasses();
		this.reset();
	});

	// this.swup.on( 'pageLoaded', (event) => {} );
}

OctaviaTheme.prototype.syncBodyClasses = function() {
	const currentPage = this.swup.cache.getCurrentPage();
	if ( ! currentPage || ! currentPage.originalContent ) {
		return;
	}

	const nextDocument = new DOMParser().parseFromString(
		currentPage.originalContent,
		'text/html'
	);
	const nextClasses = new Set( nextDocument.body.classList );
	const persistentClasses = [ 'logged-in', 'admin-bar', 'customize-support' ];

	persistentClasses.forEach( (className) => {
		if ( this.$body.hasClass( className ) ) {
			nextClasses.add( className );
		}
	});

	this.$body.attr( 'class', Array.from( nextClasses ).join( ' ' ) );
};

OctaviaTheme.prototype.initHomeSlider = function() {
	$( '.js-slider' ).flickity({
		// options
		cellAlign: 'center',
		//contain: true,
		autoPlay: 3000,
		//fullscreen: true,
		fade: true,
		prevNextButtons: false
		// imagesLoaded: true
	});
}

OctaviaTheme.prototype.setupSingleProductGallery = function() {
	const $workImageLinks = $( '.woocommerce-product-gallery__image' ).find( 'a' );
	$workImageLinks.addClass( 'data-no-swup' );
};

OctaviaTheme.prototype.setupProductNavigationKeyboard = function() {
	$( document ).off( 'keydown.octaviaProductNavigation' ).on( 'keydown.octaviaProductNavigation', (e) => {
		const isSingleProduct = this.$body.hasClass( 'single-product' );
		if ( ! isSingleProduct ) {
			return;
		}

		if ( e.altKey || e.ctrlKey || e.metaKey || e.shiftKey ) {
			return;
		}

		const activeElement = document.activeElement;
		const isTypingContext = activeElement && (
			/input|textarea|select|button/i.test( activeElement.tagName ) ||
			activeElement.isContentEditable
		);
		if ( isTypingContext ) {
			return;
		}

		if ( $( '.pswp.pswp--open' ).length ) {
			return;
		}

		if ( e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' ) {
			return;
		}

		const $navigation = $( '.woocommerce-product-navigation' );
		if ( ! $navigation.length ) {
			return;
		}

		let $targetLink = $();
		if ( e.key === 'ArrowRight' ) {
			$targetLink = $navigation.find( 'a[rel="prev"]' ).first();
		} else if ( e.key === 'ArrowLeft' ) {
			$targetLink = $navigation.find( 'a[rel="next"]' ).first();
		}

		if ( ! $targetLink.length ) {
			return;
		}

		e.preventDefault();
		$targetLink.get( 0 ).click();
	});
};

OctaviaTheme.prototype.resizeWorkImage = function() {
	const $productGalleryImage = $( '.woocommerce-product-gallery__image' ).find( 'img' );
	// console.log($productGalleryImage); !
	if ( ! $productGalleryImage) {
		return;
	}

	const window_w = this.$window.width();
	const window_h = this.$window.height();
	const image_w  = $productGalleryImage.width();
	const image_h  = $productGalleryImage.height();
	const ratio    = image_h / image_w * 100;
	$productGalleryImage.css();
};

/*
 * Toggle Submenu
 */
OctaviaTheme.prototype.toggleSubmenu = function() {
	this.$submenu.removeClass( 'open' ).addClass( 'open' );

	if (this.$submenu.hasClass( 'should-open' )) {
		this.$submenu.removeClass( 'open' ).addClass( 'open' );
	}
};

/*
 * Initialise istotope plugin on products
 */
OctaviaTheme.prototype.initProductIsotope = function() {
	this.$products.isotope(
		{
			itemSelector: '.product',
			percentPosition: true,
			masonry: {
				// use outer width of grid-sizer for columnWidth
				// columnWidth: '.grid-sizer' !
			}
		}
	);
};

/*
 * Initialise product gallery
 */
OctaviaTheme.prototype.initProductGallery = function() {
	// Initialize popup as usual.
	this.$productGallery.magnificPopup(
		{
			type: 'image',
			mainClass: 'mfp-with-zoom', // this class is for CSS animation below.

			zoom: {
				enabled: false, // By default it's false, so don't forget to enable it.

				duration: 300, // duration of the effect, in milliseconds.
				easing: 'ease-in-out', // CSS transition easing function.

				// The "opener" function should return the element from which popup will be zoomed in
				// and to which popup will be scaled down
				// By defailt it looks for an image tag.
				opener: function(openerElement) {
					// openerElement is the element on which popup was initialized, in this case its <a> tag
					// you don't need to add "opener" option if this code matches your needs, it's defailt one.
					return openerElement.is( 'img' ) ? openerElement : openerElement.find( 'img' );
				}
			}

		}
	);
};

OctaviaTheme.prototype.runAutoLinks = function() {
	// const $autoLink   = this.$body.find( '.js-auto-link' );
	const $autoLinkup = this.$body.find( '.js-auto-linkup' );
	$autoLinkup.off( 'click.octaviaAutoLink touchstart.octaviaAutoLink' ).on('click.octaviaAutoLink touchstart.octaviaAutoLink', (e) => {
		if (e.cancelable) {
			e.preventDefault();
		}

		const $this   = $( e.currentTarget );
		const $target = $( e.target );
		const $parent = $this.closest( '.js-auto-link' );
		const $link   = $parent.find( 'a' ).first();

		if ($link.length) {
			const linkHref = $link.attr( 'href' );
			console.log( 'Found link: ', linkHref );
			this.swup.loadPage({
				url: linkHref, // route of request (defaults to current url)
			});
		}
	} );
};

/*
 * Initialize all galleries on page.
 */
OctaviaTheme.prototype.initWoocommerceProductGallery = function() {
	// wc_single_product_params is required to continue.
	if ( 'undefined' === typeof wc_single_product_params || 'undefined' === typeof $.fn.wc_product_gallery ) {
		this.ensureProductGalleryVisibility();
		return false;
	}

	$( '.woocommerce-product-gallery' ).each(function() {
		const $gallery = $( this );
		const isInitialised = !! $gallery.data( 'octavia-gallery-init' );
		if ( isInitialised ) {
			return;
		}

		$gallery.trigger( 'wc-product-gallery-before-init', [this, wc_single_product_params] );
		$gallery.wc_product_gallery( wc_single_product_params );
		$gallery.trigger( 'wc-product-gallery-after-init', [this, wc_single_product_params] );
		$gallery.data( 'octavia-gallery-init', true );
	});
	this.ensureProductGalleryVisibility();
};

OctaviaTheme.prototype.ensureProductGalleryVisibility = function() {
	window.setTimeout(() => {
		$( '.woocommerce-product-gallery' ).each(function() {
			const $gallery = $( this );
			const opacity = parseFloat( $gallery.css( 'opacity' ) );
			if ( Number.isNaN( opacity ) || opacity >= 1 ) {
				return;
			}
			$gallery.css( 'opacity', 1 );
		});
	}, 250 );
};

OctaviaTheme.prototype.loadMoreProducts = function(params) {
	console.log( params );

	let canBeLoaded    = params.current_page < params.max_page; // this param allows to initiate the AJAX call only if necessary
	const bottomOffset = 1000; // the distance (in px) from the page bottom when you want to load more posts

	if (this.scrollEvent) {
		window.removeEventListener( 'scroll', this.scrollEvent );
	}

	if ( !canBeLoaded ) {
		return;
	}

	this.loadMore.setup();

	this.scrollEvent = () => {
		var data     = {
			'action': 'oct_load_more',
			'query': params.posts,
			'page' : params.current_page
		};

		const isScrollThreshold = (
			this.$document.scrollTop() + this.$window.height()
		) > (this.$document.height() - bottomOffset);

		if (isScrollThreshold && canBeLoaded) {

			$.ajax({
				url : params.ajaxurl,
				data: data,
				type: 'POST',
				beforeSend: (xhr) => {
					canBeLoaded = false;
					this.loadMore.show();
				},
				success: (data) => {
					this.loadMore.hide();
					if (data) {
						$( '.products' ).find( '.product:last-of-type' ).after( data );
						params.current_page++;
						canBeLoaded = true;
					}
				},
				error: (data) => {
					this.loadMore.hide();
					canBeLoaded = false;
				}
			});
		} else {
			// loadMore.hide();
		}
	};

	window.addEventListener( 'scroll', this.scrollEvent );
}

OctaviaTheme.prototype.reset = function() {
	console.log( "Reset" );
	this.$body.removeClass( 'woocommerce-no-js' ).addClass( 'woocommerce-js' );
	this.setupSingleProductGallery();
	this.setupProductNavigationKeyboard();
	this.initWoocommerceProductGallery();
	this.runAutoLinks();
	// this.initHomeSlider();
	// ProductGallery.openPhotoswipe();
}

//})( jQuery );


/*
 * Initialise Handvaerk.
 */
$( document ).ready(function() {
	window.OctaviaTheme = new OctaviaTheme();
});
